import { useContext,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ChangeAlert from '../components/ChangeAlert/ChangeAlert';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import Sidebar from '../components/Sidebar/Sidebar';
import TeamsTabs from '../components/Teams/TeamsTabs';
import { UserContext } from '../context/UserContext';
import { trackEventMatomoVisit } from '../helpers/matomo';
import { HeaderText } from '../StyledComponents/pages/pages';
import { Container,SubContainer } from './Styles';

export default function Teams() {
  const { t } = useTranslation('translation');
  const { changed } = useContext(UserContext);

  useEffect(() => {
    trackEventMatomoVisit('Gestão de Equipes');
  }, []);

  return (
    <Container>
      <Sidebar />
      <SubContainer>
        {changed && <ChangeAlert />}
        <Header />
        <HeaderText style={{ textAlign: 'center' }}>{t('teamManage.title')}</HeaderText>
        <div style={{
          marginBottom: '50px',
          padding: `${window.innerWidth < 800 ? '0px 2% 0px 2%' : '0px 10% 0px 10%'}`,
        }}>
          <TeamsTabs />
        </div>
        <Footer />
      </SubContainer>
    </Container>
  );
}